import { render, staticRenderFns } from "./BaseAvatar.vue?vue&type=template&id=a8a2d9a4&scoped=true"
import script from "./BaseAvatar.vue?vue&type=script&lang=js"
export * from "./BaseAvatar.vue?vue&type=script&lang=js"
import style0 from "./BaseAvatar.vue?vue&type=style&index=0&id=a8a2d9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a2d9a4",
  null
  
)

export default component.exports